export default "/images/efbf1dc9ff369b8f4cdf54871b1b1dab.avif";